"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Api = function () {
  function Api($http, $q, API_URL) {
    "ngInject";

    (0, _classCallCheck3.default)(this, Api);
    this.API_URL = API_URL;
    this.$http = $http;
    this.$q = $q;
  }

  (0, _createClass3.default)(Api, [{
    key: "call",
    value: function call(params) {

      var isAbsolute = 0 === params.url.indexOf("http://");
      if (!isAbsolute) {
        params.url = this.API_URL + params.url;
      }

      return this.$http(params).then(function (response) {
        return response.data;
      }).catch(function (error) {
        throw error;
      });
    }
  }]);
  return Api;
}();

// WEBPACK FOOTER //


exports.default = Api;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/api.js
 **/